const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Arjun Saroha</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Events Head, UPES-CSI</li>
    <li>
        3rd year student at UPES pursuing BTech in Computer Science and Engineering with specialization in Data Science
    </li>
    <li>
        Member of organising committee of various events held at UPES
    </li>
    <li>
        Huge Football enthusiast
    </li>
</ul>
</div>
</div>
</>
}

export default data;
